import random from 'lodash/random';
import memoize from 'lodash/memoize';
import flatMap from 'lodash/flatMap';
import values from 'lodash/values';
import colors from 'overrides/colors';

const colorList: string[] = flatMap(
  colors,
  (colorsByTone: string | Record<string, string>, k) => (
    typeof colorsByTone !== 'string' && !k.includes('populate')
      ? values(colorsByTone).slice(4) : []
  ),
);

export const getColorForUnique = memoize((unique: string | null): string => {
  const index = random(0, colorList.length - 1);
  return colorList[index];
});
